import GlobalLoading from '@/mixins/GlobalLoading'
import { mapGetters, mapMutations } from 'vuex'

const expiredIn = process.env.VUE_APP_ENV === 'production' ? 10 : 1

export default {
  computed: {
    ...mapGetters(['getApps', 'getAccountApps', 'getAppServices']),
    activeAccountApps() {
      return this.getAccountApps.filter(a => a.active)
    }
  },
  methods: {
    ...mapMutations(['setAccountApps', 'setApps', 'clearAccountApps']),
    async loadAppsAndAccountApps() {
      // Qualquer falha aqui deixava o loading global aberto para sempre e a
      // shell nunca renderizava (o `load` do Dashboard nem chegava a virar).
      // Boot da plataforma nao pode travar por causa de uma request que falhou.
      this.openGlobalLoad()
      try {
        await this.loadBySource('accountApp', 1)
        await this.loadBySource('app', 2)
      } catch (e) {
        window.console.error('loadAppsAndAccountApps', e)
      } finally {
        this.closeGlobalLoad()
      }
    },
    async loadBySource(modoleName, expiredFactor) {
      const method = `set${this.$parse.capitalize(modoleName)}s`
      const path = this.$parse.toSnakecase(modoleName) + 's'
      let data = this.$ls.get(`${path}_cache`)

      if (!data) {
        const response = await this.axios.get(path)
        data = this.$parse.toCamelcase(response.data)
        this.$ls.set(`${path}_cache`, data, { minutes: expiredIn * expiredFactor })
      } 
      this[method](data)
    }
  },
  mixins: [GlobalLoading],
  name: 'GetAccountApps',
}
